<template>
  <div class="settlementform">
    <PageTitle icon="fa fa-clone" main="Registro" sub="Forma de Pagamento/Recebimento" />
    <b-form v-show="mode === 'save' || mode === 'remove' || mode === 'read'">
      <input id="settlementform-id" type="hidden" v-model="settlementform.id" />
      <b-row>
        <b-col md="6" sm="12">
          <b-form-group 
            label="Descrição:" 
            label-for="settlementform-name_settlement_form">
            <b-form-input
              id="settlementform-name_settlement_form"
              type="text"
              ref="searchFocus"
              v-model="settlementform.name_settlement_form"
              required
              size="sm"
              :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
              placeholder="Nome..."
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="3" sm="12">
          <div class="form-group">
            <div class="form-check">
              <input
                class="form-check-input"
                v-model="settlementform.payment"
                true-value="1"
                false-value="0"
                type="checkbox"
                id="settlementform-payment"
                :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
              />
              <label class="form-check-label" for="settlementform-payment">Pagamento?</label>
            </div>
          </div>
        </b-col>
        <b-col md="3" sm="12">
          <div class="form-group">
            <div class="form-check">
              <input
                class="form-check-input"
                v-model="settlementform.receipt"
                true-value="1"
                false-value="0"
                type="checkbox"
                id="settlementform-receipt"
                :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
              />
              <label class="form-check-label" for="settlementform-receipt">Recebimento?</label>
            </div>
          </div>
        </b-col>
        <b-col md="3" sm="12">
          <div class="form-group">
            <div class="form-check">
              <input
                class="form-check-input"
                v-model="settlementform.direct_settlement"
                true-value="1"
                false-value="0"
                type="checkbox"
                id="settlementform-direct_settlement"
                :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
              />
              <label
                class="form-check-label"
                for="settlementform-direct_settlement"
              >Liquidação Direta?</label>
            </div>
          </div>
        </b-col>
        <b-col md="3" sm="12">
          <div class="form-group">
            <div class="form-check">
              <input
                class="form-check-input"
                v-model="settlementform.blocked"
                true-value="1"
                false-value="0"
                type="checkbox"
                id="settlementform-blocked"
                :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
              />
              <label class="form-check-label" for="settlementform-blocked">Bloqueado?</label>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="3" sm="12">
          <div class="form-group">
            <div class="form-check">
              <input
                class="form-check-input"
                v-model="settlementform.check_credit_limit"
                true-value="1"
                false-value="0"
                type="checkbox"
                id="settlementform-check_credit_limit"
                :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
              />
              <label
                class="form-check-label"
                for="settlementform-check_credit_limit"
              >Verifica Límite de Crédito?</label>
            </div>
          </div>
        </b-col>
        <b-col md="3" sm="12">
          <div class="form-group">
            <div class="form-check">
              <input
                class="form-check-input"
                v-model="settlementform.charge_track"
                true-value="1"
                false-value="0"
                type="checkbox"
                id="settlementform-charge_track"
                :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
              />
              <label
                class="form-check-label"
                for="settlementform-charge_track"
              >Acompanhento Financeiro ?</label>
            </div>
          </div>
        </b-col>
        <b-col md="3" sm="12">
          <div class="form-group">
            <div class="form-check">
              <input
                class="form-check-input"
                v-model="settlementform.credit_card"
                true-value="1"
                false-value="0"
                type="checkbox"
                id="settlementform-credit_card"
                :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
              />
              <label
                class="form-check-label"
                for="settlementform-credit_card"
              >Usar Cartão de Crédito/Débito?</label>
            </div>
          </div>
        </b-col>
        <b-col md="2" sm="6">
          <b-form-group label="NFCe Cód.:" label-for="settlementform-eletronic_invoice_form">
            <b-form-input
              id="settlementform-eletronic_invoice_form"
              type="text"
              v-model="settlementform.eletronic_invoice_form"
              required
              size="sm"
              :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
              placeholder="..."
            />
          </b-form-group>
        </b-col>
      </b-row>
      <label class="form-check-label">Operação de Venda</label>
      <b-row>
        <b-col md="2" sm="12">
          <b-form-group label="Custo:" label-for="settlementform-type_cost_id_receipt">
            <b-form-select
              id="settlementform-type_cost_id_receipt"
              size="sm"
              :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
              :options="typecosts"
              v-model="settlementform.type_cost_id_receipt"
            />
          </b-form-group>
        </b-col>
        <b-col md="2" sm="12">
          <b-form-group label="Operação:" label-for="settlementform-operation_id_receipt">
            <b-form-select
              id="settlementform-operation_id_receipt"
              @input="loadOperationsLevelOnes"
              size="sm"
              :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
              :options="operations"
              v-model="settlementform.operation_id_receipt"
            />
          </b-form-group>
        </b-col>
        <b-col md="3" sm="12">
          <b-form-group label="1º Nível:" label-for="settlementform-operation_level_one_id_receipt">
            <b-form-select
              id="settlementform-operation_level_one_id_receipt"
              @input="loadOperationsLevelTwos"
              :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
              size="sm"
              :options="operationslevelones"
              v-model="settlementform.operation_level_one_id_receipt"
            />
          </b-form-group>
        </b-col>
        <b-col md="3" sm="12">
          <b-form-group label="2º Nível:" label-for="settlementform-operation_level_two_id_receipt">
            <b-form-select
              id="settlementform-operation_level_two_id_receipt"
              size="sm"
              :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
              :options="operationsleveltwos"
              v-model="settlementform.operation_level_two_id_receipt"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-form>
       <hr v-show="mode === 'save'">
              <b-row>
                <b-col xs="12" class="sub-background">
                   <b-button  
                        size="sm" 
                        variant="light" 
                        class="mt-2  mb-2 fa fa-plus" 
                        v-show="mode !== 'save' && mode !== 'remove'"
                        @click="alterModo">
                    </b-button>
                    <b-button 
                         
                        size="sm" 
                        variant="light"
                        class="mt-2 mb-2 ml-2 fa fa-save" 
                        v-if="mode === 'save'"
                        @click="save">
                        </b-button>
                    <b-button 
                         
                        size="sm" 
                        variant="light" 
                        class="mt-2 mb-2 ml-2 fa fa-trash" 
                        v-if="mode === 'remove'"
                        @click="remove">
                        </b-button>
                    <b-button 
                        size="sm" 
                        btn-sm 
                        variant="light" 
                        class="mt-2 mb-2 ml-2 fa fa-ban"  
                        v-if="mode === 'remove' || mode === 'save' || mode === 'read' "
                        @click="reset">
                    </b-button>
                    <b-button 
                         size="sm" 
                         class="mt-2 mb-2 ml-2 fa" 
                         :class="icon" 
                         @click="[loadSettlementForms(),toggleBusy(),showTable = !showTable]" 
                         variant="light" >
                    </b-button>
                </b-col>
            </b-row>
            <br>
           <div class="col-sm-4">
                    <div class="form-group">
                        <input 
                            type="text" 
                            size="sm" 
                            icon="search" 
                            v-model="search" 
                            ref="searchFocus"
                              v-show="mode !== 'save' && mode !== 'remove'"
                            placeholder="Informe a descrição" 
                            class="form-control">
                    </div>
                </div>

        <transition name="slide" type="animation" appear>
          <b-table
            :busy="isBusy"  
            class="table-responsive"
            v-show="showTable"
            hover
            key="slide"
            head-variant="light"
            :per-page="perPage" 
            :current-page="currentPage" 
            :items="filteredList"
            :fields="fields"
          >
           <template v-slot:table-busy>
                <div class="text-center text-info my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Carregando...</strong>
                </div>
            </template>
            <template v-slot:cell(actions)="data">
              <b-button
                
                title="Detalhe do registro"
                size="sm"
                variant="light"
                @click="loadSettlementForm(data.item, 'read')"
                class="mr-2 mt-2"
              >
                <i class="fa fa-drivers-license-o"></i>
              </b-button>
              <b-button
                
                title="Editar registro"
                size="sm"
                variant="light"
                @click="loadSettlementForm(data.item)"
                class="mr-2 mt-2"
              >
                <i class="fa fa-pencil"></i>
              </b-button>
              <b-button
                
                title="Excluir registro"
                size="sm"
                variant="light"
                @click="loadSettlementForm(data.item, 'remove')"
                class="mr-2 mt-2"
              >
                <i class="fa fa-trash"></i>
              </b-button>
            </template>
          </b-table>
        </transition>
        <transition  name="slide" type="animation" appear>
            <b-pagination
                v-show="showTable"
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
                size="sm"
                aria-controls="my-table"
            ></b-pagination>
          </transition> 

  </div>
</template>

<script>
import { baseApiUrl, showError } from "@/global";
import axios from "axios";
import PageTitle from "../template/PageTitle";

export default {
  name: "SettlementForm",
  components: { PageTitle },
  data: function() {
    return {
      mode: "insert",
      search: "",
      settlementform: {},
      settlementforms: [],
      typecosts: [],
      operations: [],
      operationslevelones: [],
      operationsleveltwos: [],
      isBusy: false,
      showTable: false,
      currentPage: 1,
      perPage: 5,
      fields: [
        { key: "id", label: "Código", sortable: true },
        { key: "name_settlement_form", label: "Descrição", sortable: true },
        {
          key: "payment",
          label: "Pagamento",
          sortable: false,
          formatter: value => (value ? "Sim" : "Não")
        },
        {
          key: "receipt",
          label: "Recebimento",
          sortable: false,
          formatter: value => (value ? "Sim" : "Não")
        },
        {
          key: "direct_settlement",
          label: "Liquidação Direta",
          sortable: false,
          formatter: value => (value ? "Sim" : "Não")
        },
        {
          key: "check_credit_limit",
          label: "Verifica Límite de Crédito",
          sortable: false,
          formatter: value => (value ? "Sim" : "Não")
        },
        { key: "actions", label: "Ações" }
      ]
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    filteredList() {
      return this.settlementforms.filter(settlementform => {
        return settlementform.name_settlement_form
          .toLowerCase()
          .includes(this.search.toLowerCase());
      });
    },
    icon() {
      return this.showTable ? "fa-retweet" : "fa-search";
    },
    rows() {
            return this.settlementforms.length
        }
     },
  methods: {
    loadSettlementForms() {
      const url = `${baseApiUrl}/settlementforms`;
      axios.get(url).then(res => {
        this.settlementforms = res.data;
          this.isBusy = false
      });
    },
    toggleBusy() {
          this.isBusy = !this.isBusy
      },
    reset() {
      this.mode = "insert";
      this.loadSettlementForms();
    },
    alterModo() {
      this.mode = "save";
      this.$refs.searchFocus.focus();
      this.settlementform = {};
    },
    save() {
      const method = this.settlementform.id ? "put" : "post";
      const id = this.settlementform.id ? `/${this.settlementform.id}` : "";

      this.settlementform.user_id = this.user.id;
      axios[method](`${baseApiUrl}/settlementforms${id}`, this.settlementform)
        .then(() => {
          this.$toasted.global.defaultSuccess();
          this.reset();
        })
        .catch(showError);
    },
    remove() {
      const id = this.settlementform.id;
      axios
        .delete(`${baseApiUrl}/settlementforms/${id}`)
        .then(() => {
          this.$toasted.global.defaultSuccess();
          this.reset();
        })
        .catch(showError);
    },
    loadSettlementForm(settlementform, mode = "save") {
      this.$refs.searchFocus.focus();
      this.mode = mode;
      this.settlementform = { ...settlementform };
    },
    loadTypeCost() {
      const url = `${baseApiUrl}/typecosts`;
      axios.get(url).then(res => {
        this.typecosts = res.data.map(typecost => {
          return { value: typecost.id, text: typecost.name_type_cost };
        });
      });
    },
    loadOperation() {
      const url = `${baseApiUrl}/operations`;
      axios.get(url).then(res => {
        this.operations = res.data.map(operation => {
          return { value: operation.id, text: operation.name_operation };
        });
      });
    },
    loadOperationsLevelOnes() {
      const url = `${baseApiUrl}/operationslevelones/${this.settlementform.operation_id_receipt}/operations`;
      axios.get(url).then(res => {
        this.operationslevelones = res.data.map(operationslevelone => {
          return {
            value: operationslevelone.id,
            text: operationslevelone.name_operation_level_one
          };
        });
      });
    },
    loadOperationsLevelTwos() {
      const url = `${baseApiUrl}/operationsleveltwos/${this.settlementform.operation_level_one_id_receipt}/operationslevelones`;
      axios.get(url).then(res => {
        this.operationsleveltwos = res.data.map(operationsleveltwo => {
          return {
            value: operationsleveltwo.id,
            text: operationsleveltwo.name_operation_level_two
          };
        });
      });
    }
  },
  mounted() {
    this.loadTypeCost(),
    this.loadOperation();
  }
};
</script>

<style>

.sub-background{
      background:linear-gradient(to top, #bdc3c7, #e7ebee);
      border-radius: 35px ;
  }

.settlementform {
  font-size: 0.7rem;
}

.settlementform input,
label,
form {
  font-size: 0.7rem;
}
.settlementform button {
  font-size: 0.7rem;
}

.settlementform select {
  font-size: 0.7rem;
}

.settlementform table {
  font-size: 0.7rem;
}

@keyframes slide-in {
  from {
    transform: translateY(40px);
  }
  to {
    transform: translateY(0);
  }
}

@keyframes slide-out {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(40px);
  }
}

.slide-enter-active {
  animation: slide-in 1s ease;
  transition: opacity 1s;
}

.slide-leave-active {
  animation: slide-out 1s ease;
  transition: opacity 1s;
}

.slide-enter,
.slide-leave-to {
  opacity: 0;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}
</style>
